
import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const MessageBox = ({ title, text, type, children, className, titleClassName }) => {
  const classContainer = classNames('alert', className, {
    'alert-info': type === 'info',
    'alert-success': type === 'success',
    'alert-warning': type === 'warning',
    'alert-danger': type === 'danger',
    'alert-tip': type === 'tip'
  })

  const titleContainer = classNames(titleClassName)

  return (
    <div className={classContainer}>
      {title &&
        <h4 className={titleContainer}>{title}</h4>}
      {children}
    </div>

  )
}

MessageBox.defaultProps = {
  title: '',
  titleClassName: ''
}

MessageBox.propTypes = {
  text: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.node,
  titleClassName: PropTypes.string
}

export default MessageBox
